'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _loading_black = require('./loading_black');

var _loading_black2 = _interopRequireDefault(_loading_black);

var _loading_white = require('./loading_white');

var _loading_white2 = _interopRequireDefault(_loading_white);

var _colmo_loading = require('./colmo_loading');

var _colmo_loading2 = _interopRequireDefault(_colmo_loading);

var _colmo_rect = require('./colmo_rect');

var _colmo_rect2 = _interopRequireDefault(_colmo_rect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconMap = {
  black: JSON.stringify(_loading_black2.default),
  white: JSON.stringify(_loading_white2.default),
  colmo: JSON.stringify(_colmo_loading2.default),
  colmo_rect: JSON.stringify(_colmo_rect2.default)
};

exports.default = {
  mixins: [_colmo2.default],
  props: {
    styleConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    type_: function type_() {
      if (this.type) return this.type;
      return this._isColmo ? 'colmo' : 'black';
    },
    lottieData: function lottieData() {
      return iconMap[this.type_];
    },
    styleConfig_: function styleConfig_() {
      if (this.type_ === 'colmo_rect') return _extends({ width: '108px', height: '94px' }, this.styleConfig);
      return _extends({ width: '48px', height: '48px' }, this.styleConfig);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-spinner/index.vue
// module id = 392
// module chunks = 0 1